'use client';

import { c as _c } from "react/compiler-runtime";
import { unwrapFromResult } from '@shared/utils/helpers/resultWrapper';
import toast from '@shared/utils/helpers/toast';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Trello } from 'lucide-react';
import { useState } from 'react';
import { client } from '../../utils/trpc';
import Confirmation from '../common/Confirmation';
import { DisconnectButton, IntegrationRow } from './IntegrationList';
const TrelloCard = () => {
  const $ = _c(16);
  const queryClient = useQueryClient();
  const [showDisconnect, setShowDisconnect] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: ["trelloHasToken"],
      queryFn: _temp,
      retry: false
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: tokenStatus,
    isLoading
  } = useQuery(t0);
  const connected = !!tokenStatus?.hasToken;
  let t1;
  if ($[1] !== queryClient) {
    t1 = async () => {
      const [error] = await client.trello.disconnect.mutate();
      if (!error) {
        toast("Trello account disconnected.");
        await queryClient.invalidateQueries({
          queryKey: ["trelloHasToken"]
        });
      }
      setShowDisconnect(false);
    };
    $[1] = queryClient;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleDisconnect = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Trello size={18} />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = isLoading ? "Checking\u2026" : connected ? `Connected${tokenStatus?.username ? ` as ${tokenStatus.username}` : ""} · imports boards into your spaces` : "Connect from any board space with Import";
  let t4;
  if ($[4] !== connected || $[5] !== isLoading) {
    t4 = !isLoading && connected ? <DisconnectButton label="Trello" onClick={() => setShowDisconnect(true)} /> : undefined;
    $[4] = connected;
    $[5] = isLoading;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <IntegrationRow icon={t2} name="Trello" status={t3} actions={t4} />;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== handleDisconnect || $[11] !== showDisconnect) {
    t6 = showDisconnect && <Confirmation title="Disconnect Trello" message="Are you sure you want to disconnect your Trello account? You'll need to reconnect if you want to import boards in the future." cancelHandler={() => setShowDisconnect(false)} confirmHandler={handleDisconnect} actionButtonText="Disconnect" variant="DANGER" />;
    $[10] = handleDisconnect;
    $[11] = showDisconnect;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
export default TrelloCard;
function _temp() {
  return unwrapFromResult(client.trello.hasToken.query());
}